var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard frame",attrs:{"id":"tableau"}},[(_vm.url)?_c('v-row',{staticClass:"card-no-footer-height"},[_c('iframe',{attrs:{"src":_vm.url}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }